import { Link } from 'react-router-dom';
import { Fragment } from 'react';

import Header2 from '../../AuxiliaresPaginas/Header2';
import AyudaPacientesModal from '../../AuxiliaresPaginas/AyudaPacientesModal.js';
import DatosPacienteModal from '../../AuxiliaresPaginas/DatosPacienteModal.js';

import {
    FlexHeaderDos,
    Icon,
    Linea
} from '../../Css/StyledHeader.js';


const HeaderDos = (props) => {

    const {
        link,
        componente,
        paciente,
        color,
        fw,
        bgcolor,
        width,
        n1,
        n2,
        n3,
        n4,
        l1,
        l2,
        l3,
        l4,

        /*
        ====================================
        SELECTOR DE PACIENTE
        ====================================

        Estas props se usan, por ejemplo,
        en Estadísticas y Cobros.

        HeaderDos solamente las transmite
        a Header2.
        ====================================
        */

        selectorPaciente,
        pacientes,
        idPacienteSeleccionado,
        onCambiarPaciente,
        permitirTodosPacientes

    } = props;


    return (

        <Fragment>

            <Linea />


            <FlexHeaderDos>

                {link ? (

                    <Link to={link}>

                        <Icon
                            src={`/img/volver.svg`}
                            alt=""
                            width="20px"
                            margin="0 1rem 0 0"
                        />

                    </Link>

                ) : null}


                <Header2
                    componente={componente}
                    paciente={paciente}

                    color={color}
                    fw={fw}
                    bgcolor={bgcolor}
                    width={width}

                    n1={n1}
                    n2={n2}
                    n3={n3}
                    n4={n4}

                    l1={l1}
                    l2={l2}
                    l3={l3}
                    l4={l4}

                    /*
                    ====================================
                    SELECTOR DE PACIENTE
                    ====================================
                    */

                    selectorPaciente={
                        selectorPaciente
                    }

                    pacientes={
                        pacientes
                    }

                    idPacienteSeleccionado={
                        idPacienteSeleccionado
                    }

                    onCambiarPaciente={
                        onCambiarPaciente
                    }

                    permitirTodosPacientes={
                        permitirTodosPacientes
                    }
                />


                {componente === "Listado pacientes" ? (

                    <div>
                        <AyudaPacientesModal />
                    </div>

                ) : null}


                {componente === "Datos paciente" ? (

                    <div>
                        <DatosPacienteModal />
                    </div>

                ) : null}

            </FlexHeaderDos>

        </Fragment>

    );

};


export default HeaderDos;